import { Pipe, PipeTransform } from "@angular/core";

import { ADPResourceService as ResourceService } from "digital-core";

@Pipe({
  name: "localDate"
})
export class LocalDatePipe implements PipeTransform {
  constructor(private resourcesService: ResourceService) {}

  transform(value: any, args?: any): any {
    if (!value) {
      return "";
    }
    let dateValue = new Date(value);
    let culture = this.resourcesService.getLocalizationSettings();    
    let result = dateValue.toLocaleDateString(culture.ClientLocalLanguage);    
    return result;
  }
}
